// Deep links to sheets: real paths (`/sheet/<type>/<uuid>`), never hash routes (the Keycloak login uses the URL fragment).
// Plain module (no imports) so it can be unit tested with node: `node src/deepLinks.test.mjs`.

// link type -> API route (relative to /api). Wine profiles have no detail view, so they are not linkable.
export const LINK_ROUTES = {
  onav: '/onav',
  aspi: '/aspi',
  pairing: '/pairings',
  food: '/food-sheets',
  coffee: '/coffee',
  oil: '/oil',
  tea: '/tea',
  vinegar: '/vinegar',
};

export const LINK_TYPES = Object.keys(LINK_ROUTES);
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuid = (value) => typeof value === 'string' && UUID.test(value);

// `/sheet/<type>/<uuid>` for a linkable type and a UUID, otherwise null
export function buildSheetPath(type, id) {
  if (!Object.prototype.hasOwnProperty.call(LINK_ROUTES, type) || !isUuid(id)) return null;
  return `/sheet/${type}/${id.toLowerCase()}`;
}

// { type, id, route } for a deep-link path (trailing slashes ignored, uuid case-insensitive), otherwise null
export function parseDeepLink(pathname) {
  if (typeof pathname !== 'string') return null;
  const parts = pathname.replace(/\/+$/, '').split('/');                 // '', 'sheet', type, id
  if (parts.length !== 4 || parts[0] !== '' || parts[1] !== 'sheet') return null;
  const [, , type, id] = parts;
  if (!Object.prototype.hasOwnProperty.call(LINK_ROUTES, type) || !isUuid(id)) return null;
  return { type, id: id.toLowerCase(), route: LINK_ROUTES[type] };
}

export const isDeepLinkPath = (pathname) => parseDeepLink(pathname) !== null;

// Absolute URL of a sheet for sharing, or null
export function sheetUrl(origin, type, id) {
  const path = buildSheetPath(type, id);
  return path ? `${String(origin || '').replace(/\/+$/, '')}${path}` : null;
}
